import * as React from "react";

export const CrossIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" {...props}>
    <path d="M12 1L1 12M1 1L12 12" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);
